/**
 * @generated SignedSource<<e3ef32d50a6577386df05ee41afceaab>>
 * @relayHash afe5d9df70dbafc1c6bc2065adf357ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 397d514693057cc15024c65c4c8aaac04f5d1f856876f22b2cbe104860ca9834

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardFilterRefinementQuery } from './boardFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<boardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "397d514693057cc15024c65c4c8aaac04f5d1f856876f22b2cbe104860ca9834",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
